import { withStyles } from '@material-ui/core';
import React from 'react';

const styles = (theme) => ({
  errorContainer: {
    height: '392',
    border: '1px solid grey',
    margin: '0px 24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.dispatchPanelHeaderColor ?? '#666666',
    fontSize: theme.headerTextFontSize ?? 14
  }
});
const ErrorComponent = ({ errorMessage, classes }) => {
  return <div className={classes.errorContainer}>{errorMessage}</div>;
};

export default withStyles(styles)(ErrorComponent);
